import { useEffect, useState } from 'react';

import { cmsApiFetchReaction } from './cmsApiReactionEndpoints';
import { CmsApiReactionContext } from './types/CmsApiReactionContext';

export function useCmsApiFetchReactions(contentId: string) {
  const [loading, setLoading] = useState(false);
  const [reactionContext, setReactionContext] = useState<CmsApiReactionContext>(
    {
      reactions: { LIKE: 0, LOVE: 0, INSPIRED: 0 },
      latestReactions: [],
      ownReaction: null,
      totalReactions: 0,
    },
  );

  useEffect(() => {
    setLoading(true);
    cmsApiFetchReaction(contentId).then((fetchedReactionContext) => {
      setReactionContext(fetchedReactionContext);
      setLoading(false);
    });
  }, [contentId]);

  return { loading, reactionContext, setReactionContext };
}
